import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { SayfalamaSonuc } from '@core/models/genel/SayfalamaSonuc';
import { IslemSonuc } from '@core/models/genel/IslemSonuc';
import { BuroLisanslamaInfo } from '@core/models/genel/BuroLisanslamaInfo';

@Injectable()
export class BuroLisanslamaService {

    constructor(private http: HttpClient) { }

    ekleGuncelle(kontorSiparisInfo: BuroLisanslamaInfo): Observable<IslemSonuc> {
        return this.http.post<IslemSonuc>(environment.API_BURO_LISANSLAMA_URL, kontorSiparisInfo);
    }

    select(id: number): Observable<BuroLisanslamaInfo> {
        return this.http.get<BuroLisanslamaInfo>(environment.API_BURO_LISANSLAMA_URL + id.toString());
    }

    getData(aramaKriter?: any): Observable<SayfalamaSonuc> {
        return this.http.get<SayfalamaSonuc>(environment.API_BURO_LISANSLAMA_URL, { params: aramaKriter });
    }

    sil(id: number): Observable<any> {
        return this.http.delete<any>(environment.API_BURO_LISANSLAMA_URL + id.toString());
    }

}